import React, { useState, useContext, useEffect } from "react";
import { userContext } from "./../../UserContext";
import { useFetch } from "../../Utils/Hooks/useFetch";
import { useNotification } from "./../../Utils/Hooks/useNotification";
import { Table, Result } from "antd";
import { Card, Content } from "./../../library/src/";
import Spinner from "./../loading/Spinner";
import { useHistory } from "react-router-dom";
import { appContext } from "../../AppContext";
import { useTranslation } from "react-i18next";
import createUserMangementColumns from "../../Utils/functions/createUserManagementColumns";

export default function UserManagment() {
  const [doFetch] = useFetch();
  const { t } = useTranslation(["user", "utils", "login"]);
  const [userState] = useContext(userContext);
  const [appState, appDispatch] = useContext(appContext);
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [createNotification, NotificationType] = useNotification();
  const [dataSource, setDataSource] = useState([]);
  const [searchValue, setSearchValue] = useState(
    appState.userManagement.searchValue
  );
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setSearchValue(appState.userManagement.searchValue);
  }, [appState.userManagement.searchValue]);

  useEffect(
    () => {
      filter();
    }, // eslint-disable-next-line
    [users, searchValue]
  );

  useEffect(
    () => {
      if (userState.isLoggedIn) {
        doFetch(`/UserManagement/GetUsers`).then((response) => {
          setIsLoading(false);

          if (response.isSuccess) {
            setUsers(response.result);
            return;
          }

          createNotification(
            NotificationType.ERROR,
            t("notifications.usersNotFound.title"),
            t("notifications.usersNotFound.message")
          );
        });
      }
    }, // eslint-disable-next-line
    [userState.isLoggedIn]
  );

  function filter() {
    let newList = users;

    if (searchValue !== "") {
      newList = users.filter(
        (_) =>
          _.person?.summary
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          _.email?.toLowerCase().includes(searchValue.toLowerCase()) ||
          _.userName?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    setDataSource(newList);
  }

  if (!userState.isLoggedIn) {
    return <Spinner type="filled" />;
  }

  if (!appState.user.isAdministrator) {
    return (
      <Result
        status="403"
        title="403"
        subTitle={t("notifications.notAuthorized.message")}
      />
    );
  }

  const createColumns = createUserMangementColumns(t, appState);

  function onRowDoubleClick(record) {
    history.push(`/user-management/user?id=${record.id}`);
  }

  const tableLoading = {
    spinning: isLoading,
    indicator: <Spinner type="filled" />,
  };

  function pageChange(page, pageSize) {
    setCurrentPage(page);
  }

  function pageSizeChange(current, size) {
    setPageSize(size);
  }

  function onTableChange(pagination, filters, sorter) {
    appDispatch({
      type: "SETUSERMANAGEMENTFILTERS",
      payload: {
        filters: filters,
        sorter: sorter,
      },
    });
  }

  return (
    <>
      <Content
        pageHeader={{
          title: t("login:menuitems.userManagement"),
        }}
      >
        <Card title={t("user:users.all")} tableMode>
          <Table
            dataSource={dataSource}
            columns={createColumns}
            rowKey="id"
            loading={tableLoading}
            tableLayout="fixed"
            size="small"
            scroll={{ x: "max-content" }}
            onChange={onTableChange}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "50", "100"],
              onChange: pageChange,
              onShowSizeChange: pageSizeChange,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {}, // click row
                onDoubleClick: (event) => {
                  onRowDoubleClick(record);
                }, // double click row
                onContextMenu: (event) => {}, // right button click row
                onMouseEnter: (event) => {}, // mouse enter row
                onMouseLeave: (event) => {}, // mouse leave row
              };
            }}
          />
        </Card>
      </Content>
    </>
  );
}
